import React, { ChangeEvent } from "react";
import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";
import { ICountryFieldConfig } from "../../interfaces/countryStrategy";
import { ITargetValue } from "../../interfaces/form";
import { showInputErrors } from "../../utils/credentials";

interface IDynamicBillingFieldsProps {
  fields: ICountryFieldConfig[];
  values: Record<string, unknown>;
  errors: Record<string, string[]>;
  onChange: (_target: ITargetValue) => void;
}

const DynamicBillingFields: React.FC<IDynamicBillingFieldsProps> = ({
  fields,
  values,
  errors,
  onChange,
}) => {
  const sortedFields = [...fields].sort((a, b) => (a.order || 0) - (b.order || 0));

  const renderField = (field: ICountryFieldConfig) => {
    const fieldErrors = errors[field.id] || [];
    const hasError = fieldErrors.length > 0;

    if (field.type === "select" && field.options) {
      return (
        <FormControl key={field.id} className="m-t-20" fullWidth>
          <Typography className="f-s-14 m-b-10">{field.label}</Typography>
          <Select
            size="small"
            name={field.id}
            value={(values[field.id] as string) || ""}
            error={hasError}
            onChange={({ target }: SelectChangeEvent) =>
              onChange({ name: target.name, value: String(target.value) })
            }
          >
            {field.options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {hasError && showInputErrors(fieldErrors)}
        </FormControl>
      );
    }

    return (
      <div key={field.id}>
        <Typography className="m-t-20 f-s-14 m-b-10">{field.label}</Typography>
        <TextField
          fullWidth
          size="small"
          name={field.id}
          placeholder={field.placeholder}
          value={(values[field.id] as string) || ""}
          error={hasError}
          onChange={({ target }: ChangeEvent<HTMLInputElement>) =>
            onChange(target)
          }
          type={field.type === "select" ? "text" : field.type}
        />
        {hasError && showInputErrors(fieldErrors)}
      </div>
    );
  };

  return <>{sortedFields.map(renderField)}</>;
};

export default DynamicBillingFields;
